<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Product Services</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    </button>
</div>
<div class="modal-body">
    <div class="row">
            <div class="form-group col-12">
                <p>
                    <button class="btn btn-light" (click)="addProductService()">Add Product Service</button>
                </p>
                <div *ngIf="!productServices.length">
                    <p>There are no Product Services</p>
                </div>
                <div *ngIf="productServices.length">
                    <table class="table">
                    <thead>
                    <tr>
                        <th>Fuel Specification</th>
                        <th>Delivery Point</th>
                        <th>Iata Service Level</th>
                        <th>Operating Hours</th>
                        <th>Refueler Company Code</th>
                        <th>Title Transfer</th>
                        <th>Comments</th>
                        <th>Edit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of productServices">
                        <td>{{ (item.fuel_specification && item.fuel_specification.length>14) ? (item.fuel_specification | slice:0:14)+'..':(item.fuel_specification)}}</td>
                        <td>{{item.delivery_point.name}}</td>
                        <td>{{item.iata_service_level?.name}}</td>
                        <td>{{item.operating_hours}}</td>
                        <td>{{item.refueler_company_code?.name}}</td>
                        <td>{{item.title_transfer}}</td>
                        <td>{{item.comments}}</td>
                        <td>
                            <button (click)="addProductService(item)" title="Edit" class="btn btn-link">
                                Edit
                            </button>
                            <button [ngbPopover]="deleteConfirmation" popoverTitle="" title="Delete" class="btn btn-link ms-0 ms-md-1">
                                Delete
                            </button>
                            <ng-template #deleteConfirmation>
                                <p class="mb-2"><strong>Product service will be removed from this location.</strong></p>
                                <div class="row">
                                    <div class="col pe-1">
                                        <button (click)="p.close()" class="btn btn-light w-100">
                                            Cancel
                                        </button>
                                    </div>
                                    <div class="col ps-1">
                                        <button (click)="delete(item)" class="btn btn-danger w-100">
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
</div>
<div class="modal-footer">
    <button class="btn btn-light" (click)="close()">Close</button>
</div>
